import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { InventoryCountPageRoutingModule } from './inventory-count-routing.module';

import { InventoryCountPage } from './inventory-count.page';

import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { SharedModule } from '../../shared.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime-ex';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { RouterModule } from '@angular/router';

import { ProductListComponentModule } from '../product-list/product-list.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    InventoryCountPageRoutingModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    SharedModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TableModule,
    PaginatorModule,
    RouterModule,
    ProductListComponentModule
  ],
  declarations: [InventoryCountPage]
})
export class InventoryCountPageModule {}
